import React from "react";
import { Grid, Card, CardContent, Typography, Avatar } from "@mui/material";
import { Person, People, LocalHospital, Medication, Assignment, Vaccines, Event } from "@mui/icons-material";
import TopHeader from "../../components/common/Header/TopHeader";

import DoctorManagementMenu from "../../components/common/Menu/DoctorManagement";

const DoctorManagementDashboard = () => {
  const cardsData = [
      {
        title: "Doctors",
        metrics: {
          new: 10,
          total: 150,
          change: "+5%",
        },
        icon: <Person style={{ fontSize: 40, color: "#1976d2" }} />,
      },
      {
        title: "Patients",
        metrics: {
          new: 25,
          total: 1200,
          change: "+3%",
        },
        icon: <People style={{ fontSize: 40, color: "#388e3c" }} />,
      },
      {
        title: "Treatments",
        metrics: {
          new: 8,
          total: 300,
          change: "-2%",
        },
        icon: <LocalHospital style={{ fontSize: 40, color: "#d32f2f" }} />,
      },
      {
        title: "Health Centers",
        metrics: {
          new: 2,
          total: 50,
          change: "+1%",
        },
        icon: <LocalHospital style={{ fontSize: 40, color: "#f57c00" }} />,
      },
      {
        title: "Medicines",
        metrics: {
          new: 15,
          total: 500,
          change: "+4%",
        },
        icon: <Medication style={{ fontSize: 40, color: "#7b1fa2" }} />,
      },
      {
        title: "Prescriptions",
        metrics: {
          new: 20,
          total: 700,
          change: "+6%",
        },
        icon: <Assignment style={{ fontSize: 40, color: "#0288d1" }} />,
      },
      {
        title: "Vaccinations",
        metrics: {
          new: 5,
          total: 200,
          change: "+2%",
        },
        icon: <Vaccines style={{ fontSize: 40, color: "#c2185b" }} />,
      },
      {
        title: "Appointments",
        metrics: {
          new: 30,
          total: 1000,
          change: "+7%",
        },
        icon: <Event style={{ fontSize: 40, color: "#0097a7" }} />,
      },
    ];


  return (
    <main id="app">
      <TopHeader />
      <div id="content_wrapper">
        <section className="doctor-management-wrapper bg-white pb-5">
          <DoctorManagementMenu />

          <div className="container-fluid px-lg-5">
            
            <h2 className="text-center my-5" style={{ fontWeight: "bold", color: "#333" }}>
              Clinic Management Dashboard
            </h2>

            <Grid container spacing={3} className="dashboard-cards-container">
              {cardsData.map((card, index) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                  <Card className="dashboard-card" style={{ textAlign: "center", padding: "20px" }}>
                    <Avatar style={{ margin: "0 auto", backgroundColor: "transparent" }}>
                      {card.icon}
                    </Avatar>
                    <CardContent>
                      <Typography variant="h6" component="div">
                        {card.title}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        New: {card.metrics.new}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        Total: {card.metrics.total}
                      </Typography>
                      <Typography variant="body2" color={card.metrics.change.startsWith("+") ? "green" : "red"}>
                        Change: {card.metrics.change}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>

          </div>
        </section>
      </div>
    </main>
  );
};

export default DoctorManagementDashboard;